import React, { useEffect, useState } from 'react'
import { api } from '../../api';
import { toast } from "react-toastify";
import "./MerchantSummary.css"
import { useSelector } from "react-redux";
import { decimalTo } from '../../utils/utils'

const MerchantSummary = (props) => {
    const token = useSelector((state) => state.auth.token);
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const merchId = props.mid
    const startDate = localStorage.getItem('startDate')
    const endDate = localStorage.getItem('endDate')
    const payload = {
        merchentId: merchId,
        startDate: startDate,
        endDate: endDate
    }
    useEffect(() => {
        setLoading(true)
        api.reports.getMerchantSummary(payload,token).then(res => {
            if (res.code === 200) {
                setData(res.data.result)
            }
        }).catch((err) => {
            console.log(err, ' merch.summary rep')
            toast.error('Something went wrong');
        }).finally(() => {
            setLoading(false)
        })
         // eslint-disable-next-line
    }, [token])

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="box-row">
                        <div className='card'>
                            <div className="card card-body">
                                <div className="card card-table">
                                    <table style={{ border: '1px' }}>
                                        <thead>
                                            <tr style={{ fontSize: '13px' }}>
                                                <th>Product Name</th>
                                                <th>Quantity</th>
                                                <th>Price</th>
                                                <th>Amount</th>
                                                <th>Margin</th>
                                                <th>Net Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? <span>loading...</span> : data && data.map((dt, index) => {
                                                return (
                                                    <tr key={index} style={{ fontSize: '14px' }}>
                                                        <td>{dt.productname}</td>
                                                        <td>{dt.orderquantity}</td>
                                                        <td>{decimalTo(dt.price).toFixed(2)}</td>
                                                        <td>{decimalTo(dt.amount).toFixed(2)}</td>
                                                        <td>{decimalTo(dt.margin).toFixed(2)}</td>
                                                        <td>{decimalTo(dt.productamount).toFixed(2)}</td>
                                                    </tr>
                                                )
                                            })}
                                            {
                                                data.length === 0 &&
                                                <tr>
                                                    <td style={{ textAlign: 'center', fontSize: '12.5px' }} colSpan='5' className="noData">No data available in table</td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default MerchantSummary;
